import React from 'react';
import PropTypes from 'prop-types';

import { getResourcePath } from '@spotahome/soyuz/client';

import Footer from '../../../common/components/Footer';

import Hero from '../../../common/components/Hero';
import HeaderContainer from '../../../common/components/HeaderContainer';

// Styles
import './StaticPage.scss';

const SimplePageTemplate = props => (
  <div>
    <Hero
      title={props.title}
      subtitle={props.subtitle && props.subtitle}
      menu={<HeaderContainer />}
      backgroundImage={`url(${getResourcePath('/images/list-hero-milan.jpg')})`}
      opacity
      size="small"
    />

    <div className="container layout-static">
      <section className="grid__wrapper static-page--content">
        <div className="grid__wrapper--inner">
          <div className="grid">
            <div className="grid__col grid__col--2-of-3 grid__col--centered">
              {props.children}
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer
      locales={props.locales}
      languageSwitcherEnabled={props.languageSwitcherEnabled}
    />
  </div>
);

SimplePageTemplate.getDefaultProps = {
  title: '',
  subtitle: null,
  locales: {},
  languageSwitcherEnabled: true
};

SimplePageTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  locales: PropTypes.object,
  languageSwitcherEnabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default SimplePageTemplate;
